import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { Row, Card, CardBody, Alert } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import { easeeGetAdminUsers } from "../../redux/booking/actions";
import SaySomething from "../../components/requests/SaySomething";
import RequestHeadSection from "../../components/requestDetailPage/RequestHeadSection";
import RequestLeftSideSection from "../../components/requestDetailPage/RequestLeftSideSection";
import RequestChatSection from "../../components/requestDetailPage/RequestChatSection";
import RequestInfoSection from "../../components/requestDetailPage/RequestInfoSection";

class RequestDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAlert: true
    };
  }

  componentDidMount() {
    this.props.easeeGetAdminUsers();
  }

  onDismissAlert = () => {
    this.setState({ visibleAlert: false });
  };

  render() {
    const {
      allRequestItems,
      addRequestLoading,
      addCommentLoading,
      match,
      intl: { messages },
      staffId,
      history,
      loading,
    } = this.props;

    const { visibleAlert } = this.state;

    let request = allRequestItems?.[match.params?.id];

    if (!request) {
      if (loading) return (<div className="loading" />)

      return (
        <div className="text-center">
          <div className="list-item-heading mb-2 text-muted" style={{ fontSize: "25px" }}>
            <i className="iconsminds-information text-muted" />
            <IntlMessages id="request.wrong_request_page" />
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <Row className="survey-app">
          <Colxx xxs="12">
            <Fragment>
              <RequestHeadSection
                request={request}
                history={history}
              />
            </Fragment>

            <Fragment>
              <Row>
                <Colxx xxs="12" lg="3" className="mb-4">
                  {!addRequestLoading && !addCommentLoading ?
                    (
                      <RequestLeftSideSection
                        request={request}
                        match={match}
                      />
                    ) : (
                      <Card className="mb-4 text-center">
                        <CardBody>
                          <div className="loading" style={{ position: "inherit" }} />
                        </CardBody>
                      </Card>
                    )
                  }
                </Colxx>

                <Colxx xxs="12" lg="8">
                  <RequestInfoSection
                    request={request}
                  />

                  <RequestChatSection
                    request={request}
                  />

                  <SaySomething
                    placeholder={messages["request.chat_say_something"]}
                    request={request}
                    staffId={staffId}
                  />
                </Colxx>
              </Row>
            </Fragment>
          </Colxx >
        </Row >
        {request?.booking?.status === "awaiting_approval" &&
          (
            <div style={{ position: "fixed", zIndex: "9999", top: "5.2rem", right: "1rem" }}>
              <Alert isOpen={visibleAlert} toggle={this.onDismissAlert} color="danger"
                style={{ width: "20rem", fontSize: "14px" }}>
                <IntlMessages id="request.awaiting_approval_status_message" />
              </Alert>
            </div>
          )
        }
      </Fragment >
    );
  }
}

const mapStateToProps = ({ requestApp, alacarteApp, settings, auth }) => {
  const {
    allRequestItems, addRequestLoading, addCommentLoading, loading
  } = requestApp;

  let staffId;
  if (auth && auth.profile && auth.profile.sub) {
    staffId = auth.profile.sub;
  }

  return {
    allRequestItems,
    addRequestLoading,
    addCommentLoading,
    loading,
    settings,
    alacarteApp,
    staffId
  };
};

const mapActionsToProps = {
  easeeGetAdminUsers
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(RequestDetailsContainer)
);
